












import { Component, Prop, Vue } from 'vue-property-decorator';
import { Md5 } from 'md5-typescript';
import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';

const url: string = 'https://bcp.carnegosystems.net/';


@Component({
  components: {},
})
export default class SensorInfo extends Vue {

  get sensor_name() {
    return (this.$store.getters.FirstInfo ? this.$store.getters.FirstInfo.sensor_name : '');
  }

  get bcpid() {
    return this.$store.getters.BcpIds[0];
  }

  get bmos_id() {
    return (this.$store.getters.FirstInfo ? this.$store.getters.FirstInfo.id : '');
  }

  get description() {
    return (this.$store.getters.FirstInfo ? this.$store.getters.FirstInfo.description : '');
  }

  get total_values() {
    return 0;
  }

  get test() {
    return this.$store.getters.Test;
  }

  private created() {
    // this.get_sensor_info();
  }
}
